export default __webpack_public_path__ + "static/media/linkedin.0d62f2bf.png";